const generateCoRelationID = () => {
  const timeStamp = Date.now();
  const randomNumber = Math.floor(Math.random() * 1000000).toString(16);
  return `${timeStamp}:${randomNumber}`;
};
export default generateCoRelationID;
